<div
    class="evida-bullet p-small mt-small {{ bulletClass }}"
    [ngClass]="{ 'evida-bullet--centered-text': centeredText }"
>
    @if (content) {
        <div class="evida-bullet_point">{{ content }}</div>
    }
    @if (icon) {
        <div class="evida-bullet_point evida-bullet_point--icon">
            <mat-icon class="fg-green" mat-list-icon>{{ icon }}</mat-icon>
        </div>
    }
    <div class="evida-bullet_content pl-medium">
        <ng-content></ng-content>
    </div>
</div>
